import { Attributes } from '@leverege/ui-attributes';
const opts = {
  filterable: true,
  sortable: false
};
export default {
  id: 'sale.recovrProductsSold',
  name: 'sale.recovrProductsSold',
  displayName: 'RecovR Products Sold',
  valueType: 'string',
  objectType: 'sale',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const saleType = obj?.data?.type;
    if (saleType !== 'vehicle-with-locator') {
      return null;
    }
    const productTypes = obj?.data?.productTypes;
    let val = '';
    if (!productTypes || productTypes.recovr) {
      val = 'Locator';
    }
    if (productTypes?.recovrKeys) {
      const keyCount = Attributes.get('sale.keysCount', 'sale', obj);
      val += val ? `|Tags (${keyCount})` : `Tags (${keyCount})`;
    }
    return val;
  }
};